import { TrackEventName as EventName, TrackEvent as Event } from '../event';

const observeMatchEvent = () => {
  // bz比赛曝光事件上报
  Event.safeOn(EventName.BZ_MATCH_EXPOSE, (data = {}) => {
    const val = {
      ...data,
      event: EventName.BZ_MATCH_EXPOSE,
    };
    Event.emit(EventName.SENSORS_TRACK, val);
  });
  // bz比赛点击事件上报
  Event.safeOn(EventName.BZ_MATCH_CLICK, (data = {}) => {
    const val = {
      ...data,
      event: EventName.BZ_MATCH_CLICK,
    };
    Event.emit(EventName.SENSORS_TRACK, val);
  });
};

export default observeMatchEvent;
